import React, { Component, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "../DataTable";
import _ from "lodash";
import { selectAlertStatus } from "../../ShareFunction";
import { Button } from "react-bootstrap";
import { Avatar } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import { green, pink } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import SplitNumber from "../../_Components/SplitNumber";
import moment from "moment-jalaali";

let showPrice = Intl.NumberFormat("en-US");
const useStyles = styled({
  pinkAvatar: {
    marginTop: 10,
    marginRight: 2,
    marginBottom: 10,
    color: "#fff",
    width: "22px",
    height: "22px",
    alignItems: "end",
  },
});

function DataGridOrders({ data }) {
  const classes = useStyles({});

  const changData = (rowData, isCanceledStatus = false) => {
    let classStyle = {};

    // جدید = 0,
    //     در_حال_پیگیری = 1,
    //     رهاسازی = 2,
    //     انجام_شده = 3,
    //     انجام_نشده = 4,
    //کنسلی
    // جدید = 0,
    // درخواست_کنسلی = 1,
    // پیگیری_کنسلی = 2,
    // رهاسازی = 3,
    // کنسل_شد = 4,
    // رد_درخواست_کنسلی = 5,
    if (isCanceledStatus) {
      let cancelStatusesArray = [
        { cancelStatus: 1, status: "درخواست_کنسلی", bgColor: "#f64e60", color: "", bdColor: "", count: 0 },
        {
          cancelStatus: 2,
          status: "پیگیری کنسلی",
          bgColor: "#eee5ff",
          color: "#fff",
          bdColor: "transparent",
          count: 0,
        },
        { cancelStatus: 3, status: "رهاسازی کنسلی", bgColor: "#f64e60", color: "", bdColor: "transparent", count: 0 },
        { cancelStatus: 4, status: "کنسل شد", bgColor: "#99260766", color: "", bdColor: "transparent", count: 0 },
        {
          cancelStatus: 5,
          status: "رد درخواست کنسلی",
          bgColor: "#d5950e66",
          color: "",
          bdColor: "transparent",
          count: 0,
        },
      ];

      cancelStatusesArray.map((state) => {
        let count = 0;
        rowData.basketItems.map((basketItems) => {
          count += _.filter(basketItems.basketItemPersons, function (basketItemPersons) {
            return basketItemPersons.cancelStatus == state.cancelStatus && basketItemPersons.cancelStatus != 0;
          }).length;
        });
        state.count = count;
      });

      return (
        <>
          {" "}
          <Grid container justify="center" alignItems="center" style={{ justifyContent: "center" }}>
            {cancelStatusesArray.map(
              (item, idx) =>
                item.count != 0 && (
                  <div
                    key={idx}
                    className="" style={{ borderBottom: "4px solid transparent" }}
                  >
                    <Avatar
                      sx={{ width: 24, height: 24 }}
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-custom-class="tooltip-dark"
                      title={item.status}
                      data-bs-delay-hide="1000"
                      className={classes.pinkAvatar}
                      style={{
                        color: item.color != "" && item.color,
                        backgroundColor: item.bgColor,
                        borderColor: item.bdColor != "" && item.bdColor,
                      }}
                    >
                      {item.count}{" "}
                    </Avatar>
                  </div>
                ),
            )}
          </Grid>
        </>
      );
    } else {
      let statusesArray = [
        { status: "جدید", bgColor: "#3699ff", count: 0 },
        { status: "در_حال_پیگیری", bgColor: "rgb(182 206 232)", count: 0 },
        { status: "رهاسازی", bgColor: "#3699ff", count: 0 },
        { status: "انجام_شده", bgColor: "#40900378", count: 0 },
        { status: "انجام_نشده", bgColor: "#d55e0185", count: 0 },
      ];
      if (rowData.trackingTheCurrentUser) {
        classStyle = { borderBottom: "4px solid #000" };
      } else {
        classStyle = { borderBottom: "4px solid transparent" };
      }
      statusesArray.map((state) => {
        let count = 0;
        rowData.basketItems.map((basketItems) => {
          count += _.filter(basketItems.basketItemPersons, function (basketItemPersons) {
            return basketItemPersons.currentStatusS == state.status && basketItemPersons.cancelStatus != 4;
          }).length;
        });
        state.count = count;
      });
      return (
        <>
          {" "}
          <Grid container justify="center" alignItems="center" style={{ justifyContent: "center" }}>
            {statusesArray.map(
              (item, idx) =>
                item.count != 0 &&
                (item.status == "در_حال_پیگیری" && rowData.trackingTheCurrentUser ? (
                  <div
                    key={idx}
                    style={{ borderBottom: "4px solid #9db7d3" }}
                  >
                    <Avatar
                      sx={{ width: 24, height: 24 }}
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-custom-class="tooltip-dark"
                      title={item.status}
                      data-bs-delay-hide="1000"
                      className={classes.pinkAvatar}
                      style={{ backgroundColor: item.bgColor }}
                    >
                      {item.count}{" "}
                    </Avatar>
                  </div>
                ) : (
                  <div
                    key={idx}
                    style={{ borderBottom: "4px solid transparent" }}
                  >
                    <Avatar
                      sx={{ width: 24, height: 24 }}
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-custom-class="tooltip-dark"
                      title={item.status}
                      data-bs-delay-hide="1000"
                      className={classes.pinkAvatar}
                      style={{ backgroundColor: item.bgColor }}
                    >
                      {item.count}{" "}
                    </Avatar>
                  </div>
                )),
            )}
          </Grid>
        </>
      );
    }
  };

  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: "100px",
      maxWidth: "100px",
    },
    {
      accessor: "createdFullName",
      Header: "نام ونام خانوادگی",
      minWidth: "150px",
      maxWidth: "150px",
    },
    {
      accessor: "phoneNumber",
      Header: "شماره تماس",
      minWidth: "100px",
      maxWidth: "100px",
    },
    {
      accessor: "originalPrice",
      Header: "قیمت اصلی",
      minWidth: "100px",
      maxWidth: "100px",
      Cell: ({ row }) => (
        <div style={{ textDecoration: "line-through" }}>
          <SplitNumber number={row.original.originalPrice} />
        </div>
      ),
    },
    {
      accessor: "price",
      Header: "قیمت",
      minWidth: "100px",
      maxWidth: "100px",
      
  Footer: (info) => {
    const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.price + sum, 0), [info.rows]);
    return (
      <div className="text-center success">
        {" "}
        <SplitNumber number={total} />
      </div>
    );
  },
      Cell: ({ row }) => showPrice.format(row.original.price),
    },
    {
      accessor: "warantyAmount",
      Header: "تامین کننده",
      minWidth: "100px",
      maxWidth: "100px",
      Footer: (info) => {
      
        const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.warantyAmount + sum, 0), [info.rows]);
        return (
          <div className="text-center success">
            {" "}
            <SplitNumber number={total} />
          </div>
        );
      },
      Cell: ({ row }) =>
        row.original.warantyAmount >= 0 ? (
          <div className="">
            <SplitNumber number={row.original.warantyAmount} />
          </div>
        ) : (
          <div className="text-danger">
            <SplitNumber number={row.original.warantyAmount} />
          </div>
        ),
    },
    {
      accessor: "statusS",
      Header: "وضعیت پرداخت",
      minWidth: "150px",
      maxWidth: "150px",
    },
    {
      accessor: "statusBasketPerson",
      Header: " وضعیت آیتم ها",
      minWidth: "100px",
      maxWidth: "100px",
      align: "center",
      Cell: ({ row }) => <div>{changData(row.original)}</div>,
    },
    {
      accessor: "cancelStatusBasketPerson",
      Header: " وضعیت کنسلی",
      minWidth: "100px",
      maxWidth: "100px",
      align: "center",
      Cell: ({ row }) => <div>{changData(row.original, true)}</div>,
    },
    {
      accessor: "commisonAgentCompanyName",
      Header: "نماینده فروش",
      minWidth: 100,
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: "90px",
      maxWidth: "90px",
      // Cell: ({ row }) => (
      //   moment(row.original.createdPersianTime).format("jYYYY/jM/jD  HH:mm")
      // ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: "100px",
      maxWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          {/* <a className="btn btn-light-primary btn-sm mr-2 btn-icon" href={`/viewOrderContents/${row.original.id}`}   >
                                    <i className='far fa-edit text-small'></i>
                            </a> */}
          <Link to={`/viewOrderContents/${row.original.id}`} title="ویرایش">
            <Button className="btn btn-light-primary ">
              <i className="far fa-edit text-small"></i>
            </Button>
          </Link>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    show_footer: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      {/* {changData(data)} */}
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridOrders;
